import React from "react";
import {List} from "semantic-ui-react";

function linkify(text = "") {
    const out = [];
    const re = /https?:\/\/[^\s]+/gi;
    let last = 0, m, k = 0;

    while ((m = re.exec(text))) {
        if (m.index > last) out.push(text.slice(last, m.index));
        const raw = m[0];
        const href = raw.replace(/[),.;!?]+$/g, "");
        out.push(
            <a key={`lnk-${k++}`} href={href} target="_blank" rel="noopener noreferrer">
                {href}
            </a>
        );
        last = m.index + raw.length;
    }
    if (last < text.length) out.push(text.slice(last));
    return out;
}

function renderBlock(b, i) {
    if (!b || !b.type) return null

    switch (b.type) {
        case "heading":
        case "listHeading": {
            const className =
                    b.type === "listHeading"
                    ? "smaller noMargin bold neutral700Text"
                    : "smaller bold neutral700Text";
            return (
                <p className={className} key={i}>
                    <strong>{b.text}</strong>
                </p>
            )
        }

        case "paragraph":
            return (
                <p className="smaller neutral700Text" key={i}>
                    {linkify(b.text || "")}
                </p>
            )

        case "list": {
            const items = b.listItems || []
            return (
                <List key={i} bulleted className="small customLanguageList">
                    {items.map((it, j) => (
                        <List.Item
                            className="smaller"
                            key={j}
                            style={{ display: "flex", alignItems: "center" }}
                        >
                            {linkify(String(it || ""))}
                        </List.Item>
                    ))}
                </List>
            )
        }

        default:
            return null
    }
}

export default function CustomLanguageBuilder({ strings }) {
    const blocks = strings?.blocks || []
    if (!blocks.length) return null
    return <>{blocks.map(renderBlock)}</>
}
